var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-component"}},[_c('ph-spotify-logo',{attrs:{"weight":"fill","size":"56"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }